export const GET_API = "GET_API";
export const GET_API_SUCCESS = "GET_API_SUCCESS";
export const GET_API_FAIL = "GET_API_FAIL";

export const ADD_API_SUCCESS = "ADD_API_SUCCESS";
export const ADD_API_FAIL = "ADD_API_FAIL";
export const UPDATE_API_SUCCESS = "UPDATE_API_SUCCESS";
export const DELETE_API_SUCCESS = "DELETE_API_SUCCESS";
